import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../Projects/ProjectCards";
import Particle from "../Particle";
import VideoIntro from "../VideoIntro/VideoIntro";
import "./style.css";

function Demo() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading pb-5">
          Demo of our proposal
        </h1>
        {/* video of demonstation of the tool  */}
        <Row>
          <VideoIntro />
        </Row>
        <br>
        </br>
        <br>
        </br>
        {/* <Row>
          <h3 className="project-heading">
            References
          </h3>
          <p className="home-about-body white">
            The world literature Knowledge Graph: <a href="https://literaturegraph.di.unito.it/" target="_blank">Link</a>
          </p>
          <p className="home-about-body white pb-5 mb-5">
            GraphBRAIN tool: <a href="" target="_blank">Link</a>
          </p>
        </Row> */}

      </Container>
    </Container >
  );
}

export default Demo;
